import React, { Component } from "react";
import { BaseComponent, required, trim } from "BaseComponent";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { isEmpty } from "BaseFunctions";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";
import { confirmAlert } from "react-confirm-alert";
import _ from "lodash";

import {
  fetchTemplatesWizardStep,
  saveTemplatesWizardData,
  showConnectDomainModal,
  saveConnectDomainData,
} from "../../actions";

class ConnectDomain extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModal: false,
      // disabledCheckAvailability: true,
    };
  }

  onSubmitForm = (values) => {
    this.setState({ loading: true });

    this.props.saveConnectDomainData({ values: values, isconnected: true });

    confirmAlert({
      title: "Connect your domain",
      message:
        "Great! Your domain is now linked to Eventify and should come into effect in a few minutes to 48hrs (in some cases)",
      confirmLabel: "Done",
      cancelLabel: "",
      buttons: [
        {
          label: "Done",
          onClick: () => {
            this.setState({ loading: false });
            this.close();
          },
        },
        {
          label: "",
          onClick: () => {
            this.setState({ loading: false });
          },
        },
      ],
    });
  };

  open() {
    this.props.showConnectDomainModal({ showModal: true });
  }

  close() {
    this.props.showConnectDomainModal({ showModal: false });
  }

  renderFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12";
    // var inputClasses = "col-sm-12 col-sm-offset-0 d-flex";
    var inputClasses = "col-sm-12 col-sm-offset-0";
    var noteClasses = "col-sm-12 col-sm-offset-0 text-muted-custom";

    return (
      <div className={divClassName}>
        <label className={labelClasses} style={{ color: "#767988" }}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>

        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
            max={field.max ? field.max : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>

        <div className={noteClasses}>
          <p>{field.note}</p>
        </div>
      </div>
    );
  }

  // handleChange = (event, newValue, previousValue, name) => {

  //     if (newValue) {
  //         this.setState({ disabledCheckAvailability: false });
  //     }
  //     else {
  //         this.setState({ disabledCheckAvailability: true });
  //     }
  // }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      TemplatesWizardStep,
      TemplatesWizardData,
      connectDomainModal,
      connectDomainData,
    } = this.props;

    return (
      <div>
        <Modal
          className="modal-container"
          show={connectDomainModal.showModal === true ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header>
            <div className="import-modal-title">Connect your domain</div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={(e) => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div style={{ width: "100%", marginBottom: 10 }}>
              <form onSubmit={handleSubmit(this.onSubmitForm)}>
                <div className="row">
                  <div className="col-md-12">
                    <Field
                      name="userdomainname"
                      label={"What is your domain name?"}
                      placeholder={"Enter your available domain name"}
                      note={
                        "Fill in the domain name you have purchased for your website"
                      }
                      type="text"
                      mandatory="true"
                      component={this.renderFieldText}
                      validate={required}
                      // onChange={(event, newValue, previousValue, name) => this.handleChange(event, newValue, previousValue, name)}
                      // disabledCheckAvailability={this.state.disabledCheckAvailability}
                      normalize={trim}
                      onButtonClick={this.dummy}
                    />

                    <div className="form-group">
                      <label
                        className="control-label-top col-sm-12"
                        style={{ color: "#767988" }}
                      >
                        <br />
                        <br />{" "}
                        <div className=""> Point to verify your domain: </div>
                        <div className="ml-40 mt-10">
                          {" "}
                          - Login to your hosting provider on a new tab{" "}
                        </div>
                        <div className="ml-40 mt-10">
                          {" "}
                          - Make sure you use Quick Connect on your hosting
                          provider's settings to link your domain to Eventify{" "}
                        </div>
                        <div className="ml-40 mt-10">
                          {" "}
                          - Come back to Eventify and click the below button
                          "Verify connection" to check that your domain settings
                          were updated{" "}
                        </div>
                      </label>
                    </div>

                    <div className="col-md-12 text-center">
                      <Button
                        className="btn-custom-blue mt-70 mb-10"
                        loading={this.state.loading}
                        disabled={pristine || invalid || submitting}
                        type="submit"
                      >
                        Verify Connection
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-custom-white"
              onClick={(e) => this.close()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  return errors;
}

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  if (state.connectDomainData && !_.isEmpty(state.connectDomainData)) {
    initVals = state.connectDomainData.values;
    toEdit = true;
  } else if (
    state.redeploy &&
    !_.isEmpty(state.redeploy) &&
    state.redeploy.redeploy &&
    state.redeploy.from == "domain" &&
    !_.isEmpty(state.redeploy.data) &&
    state.redeploy.data.domain_name != null
  ) {
    initVals = {
      option: "connectown",
      userdomainname: state.redeploy.data.domain_name,
      eventifydomainname: undefined,
    };

    toEdit = true;
  } else if (
    state.redeploy &&
    !_.isEmpty(state.redeploy) &&
    state.redeploy.redeploy &&
    state.redeploy.from != "domain" &&
    state.siteDetails &&
    state.siteDetails.resource &&
    !_.isEmpty(state.siteDetails.resource) &&
    state.siteDetails.resource[0].domain_name != null
  ) {
    initVals = {
      option: "connectown",
      userdomainname: state.siteDetails.resource[0].domain_name,
      eventifydomainname: undefined,
    };

    toEdit = true;
  }

  return {
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
    TemplatesWizardStep: state.TemplatesWizardStep,
    TemplatesWizardData: state.TemplatesWizardData,
    connectDomainModal: state.connectDomainModal,
    connectDomainData: state.connectDomainData,

    siteDetails: state.siteDetails,
    redeploy: state.redeploy,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchTemplatesWizardStep,
  saveTemplatesWizardData,
  showConnectDomainModal,
  saveConnectDomainData,
})(
  reduxForm({
    validate,
    form: "TemplatesWizardConnectDomainForm",
    enableReinitialize: true,
    // keepDirtyOnReinitialize: true
  })(ConnectDomain)
);
